// Live re-sort of the server-ordered featured list (top 7): whoever is
// online according to the LIVE availability map floats to the top, so the
// order reacts immediately when a professional goes online/offline while
// the home page is open. Within each tier the server order (last connected
// call, see getFeaturedProfessionals) is preserved — the sort is stable.
// Busy is not tier 1: not immediately callable.

export function sortFeaturedLive<
  T extends { id: string; onlineStatus?: 'online' | 'busy' | 'offline' | 'paused' },
>(
  list: T[],
  getStatus: (
    professionalId: string,
    fallback?: 'online' | 'busy' | 'offline' | 'paused'
  ) => string
): T[] {
  const tier = (p: T) => (getStatus(p.id, p.onlineStatus) === 'online' ? 0 : 1);
  return [...list].sort((a, b) => tier(a) - tier(b));
}
